import { Injectable } from '@angular/core';
import { Filter } from 'src/app/shared/models/filter';
import { IFilterModel } from 'src/app/shared/models/filter-model';

export interface DateRange {
  start: string;
  end: string;
}

@Injectable()
export class ShippingAccountingFilterAdapter {
  createDefaultFilter(): { filter: Filter; dateRange: DateRange } {
    const today = new Date();
    const dateRange = this.monthToDateRange(today);
    const filter = new Filter().size(10);
    filter.date('date', dateRange.start, 'after');
    filter.date('date', dateRange.end, 'before');
    return { filter, dateRange };
  }

  withMonthFilter(filter: Filter, date: Date): DateRange {
    const dateRange = this.monthToDateRange(date);
    filter.date('date', dateRange.start, 'after');
    filter.date('date', dateRange.end, 'before');
    return dateRange;
  }

  withFilterModels(filter: Filter, filters: readonly IFilterModel[]): Filter {
    filters.forEach((item) => filter.setFilter(item.key, item.filter));
    return filter;
  }

  private monthToDateRange(date: Date): DateRange {
    const start = this.toIsoDate(new Date(date.getFullYear(), date.getMonth(), 1));
    const end = this.toIsoDate(new Date(date.getFullYear(), date.getMonth() + 1, 0));
    return { start, end };
  }

  private toIsoDate(date: Date): string {
    return date.toISOString().slice(0, 10);
  }
}
